import { defineComponent as _defineComponent } from 'vue'
import { Modal } from '@warrenbrasil/nebraska-web';
import { EMethods } from '@/modules/authentication/views/SecurityView/components/MultiFactorAuthentication/types';
import { ButtonBoxIcon } from '@/modules/authentication/views/SecurityView/components/MFALogin/components/ButtonBoxIcon';

interface Props {
  value: boolean;
}

interface Emits {
  (event: 'input', value: boolean): void;
  (event: 'on-without-phone-select'): void;
  (event: 'on-method-select', value: EMethods): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectMFAMethodModal',
  props: {
    value: { type: Boolean }
  },
  emits: ["input", "on-without-phone-select", "on-method-select"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'input', value: boolean): void;
  (event: 'on-without-phone-select'): void;
  (event: 'on-method-select', value: EMethods): void;
}), expose: any, slots: any, attrs: any }) {




const buttonOption = [
  {
    label: 'Receber por SMS',
    secondaryText: 'O código será enviado por mensagem.',
    icon: 'AA0060',
    action: () => {
      emit('on-method-select', EMethods.SMS);
      closeModal();
    }
  },
  {
    label: 'Receber pelo aplicativo',
    secondaryText: 'O código será enviado por notificação.',
    icon: 'EC0020',
    action: () => {
      emit('on-method-select', EMethods.PUSH);
      closeModal();
    }
  },
  {
    label: 'Estou sem celular',
    secondaryText: 'Apenas funções de emergência disponíveis.',
    icon: 'EF0062',
    action: () => emit('on-without-phone-select')
  }
];

function closeModal() {
  emit('input', false);
}

return { __sfc: true,emit, buttonOption, closeModal, Modal, ButtonBoxIcon }
}

})